import { times } from 'lodash'
import * as Yup from 'yup'
import {
  cardWidgetItemComponentValidationSchema,
  getInitialCardWidgetItemComponentValues,
} from '../components/Card'

const CARD_COUNT = 2

export const FIELD_NAMES = {
  CARDS: 'cards',
}

export const getInitialTwoColumnCardWidgetItemValues = () => ({
  [FIELD_NAMES.CARDS]: times(
    CARD_COUNT,
    getInitialCardWidgetItemComponentValues
  ),
})

export const twoColumnCardWidgetItemValidationSchema = Yup.object().shape({
  content: Yup.object().shape({
    [FIELD_NAMES.CARDS]: Yup.array()
      .of(cardWidgetItemComponentValidationSchema)
      .min(CARD_COUNT)
      .max(CARD_COUNT)
      .required(),
  }),
})
